import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

/*
 * @id     fest.web
 * @do     monter_application
 * @role   orchestration
 * @layer  ui
 * @human  Point d'entrée du client Festosh : monte l'application React (fournisseurs et routeur).
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
